import React, { Fragment } from 'react'
import { Head, withSiteData } from 'react-static'
import styled from 'styled-components'
import Dino from '../assets/404.png'
import { Flex } from '../styles/styled-common'

const Img = styled.img`
  width: 300px;
`

const Div = styled(Flex)`
  min-height: 100%;
  height: 50vh;
  margin: 0 auto;
  text-align: center;
  width: 1000px;
`

export default withSiteData(({ siteData }) => (
  <Fragment>
    <Head>
      <title>Page Not Found - {siteData.site.name}</title>
    </Head>
    <Div flexDirection="column">
      <Img src={Dino} alt="404" />
      <h1>Woops... We couldn't find this page</h1>
    </Div>
  </Fragment>
))



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/404.tsx